import { constructsData, reportingCategory } from "../Components/StudentPerformanceDashboard/data";
import newConstructsData from '../Components/StudentPerformanceDashboard/newData.json'

const initialState = {
  activeTab: '',
  activeBehaviorsection: '',
  constructData: null,
  contextData: null,
  loading: false,
  constructLoading: false,
  constructError: null,
  error: null,
  contextError: null,
  isUpdateBehaviors: false,
  pageOverview: {},
  userId: '',
  tabs: [
    { value: "Slide", label: "Slide", disabled: true },
    { value: "Stack", label: "Stack", disabled: true },
    { value: "Match", label: "Match", disabled: true },
  ]
};

const calculatePercentages = (behaviors, totalDivisor) => {
  const totalPercentageValue = behaviors.reduce((acc, value) => acc + value.percentage, 0);
  const averagePercentage = +(totalPercentageValue / totalDivisor).toFixed(2);
  const result = ((1 - averagePercentage) / 2).toFixed(3);

  return { totalPercentageValue, averagePercentage, result };
};

const updateBehaviors = (behaviorData, label, newValue) => {
  return behaviorData.map((item) => {
    if (item?.label === label) {
      return {
        ...item,
        originalPercentage: item.originalPercentage ?? item.percentage,
        percentage: newValue,
      };
    }
    return item;
  });
};

const resetBehaviors = (behaviorData) => {
  return behaviorData.map((item) => ({
    ...item,
    percentage: item.originalPercentage ?? item.percentage,
  }));
};

const updateActiveTabs = (tabs, statusData, disabled) => {
  return tabs?.map(tab => ({
    ...tab,
    disabled : statusData[tab?.label.toLowerCase()] !== undefined ? !statusData[tab?.label.toLowerCase()] : tab?.disabled
  }))
}
const updateConstructLabel = (constructLabel, activeBehaviorsection, averagePercentage) => {
  return constructLabel?.map((item) =>
    item.behaviors_graph_key === activeBehaviorsection
      ? { ...item, percentage: averagePercentage }
      : item
  );
};

const studentPerformanceConstructReducer = (state = initialState, action) => {
  switch (action.type) {
    case 'SET_ACTIVE_TAB':
      return { ...state, activeTab: action.payload, contextData: {} };
    case 'SET_ACTIVE_BEHAVIOR_SECTION': {
      return { ...state, activeBehaviorsection: action.payload }
    }
    case "SET_USER_ID_FOR_REPORTIG": {
      return { ...state, userId: action.payload, error: '' }
    }
    case "SET_OVERVIEW_DATA": {
      let category = action.payload?.category
      let categoryName = reportingCategory[category]
      let { contexts, ...rest } = newConstructsData.find((item) => item.name.toLowerCase() === categoryName.toLowerCase()) || {}

      return { ...state, category, pageOverview: rest || {} }
    }
    case "FETCH_CONSTRUCT_DATA_SUCCESS": {

      return {
        ...state,
        contextData: action.payload?.data,
        activeBehaviorsection: Object.keys(action.payload?.data?.behaviors || {})?.[0] || action.payload?.data?.construct_label[0]?.behavior_graph_key,
        error: '',
      }
    }
    case "FETCH_CONSTRUCT_DATA_ERROR": {
      return {
        ...state,
        contextData: {},
        error: action.payload?.response?.data?.message,

      }
    }
    case "FETCH_CONSTRUCT_BEHAVIOR_DATA_SUCCESS": {
      return {
        ...state,
        contextData: {
          ...state?.contextData,
          behaviors: action?.payload
        }
      }
    }

    case "FETCH_CONSTRUCT_BEHAVIOR_DATA_ERROR": {
      return {
        ...state, constructLoading: false,
        contextData: {
          ...state?.contextData,
          behaviors: {}
        }
      }
    }
    case "UPDATE_PREDICTION_dATA_SUCCESS": {
      let { prediction_value } = action.payload
      let updateConstructLabel = state?.contextData?.construct_label.map(item => prediction_value[item?.behavior_graph_key] ? { ...item, percentage: +prediction_value[item?.behavior_graph_key] } : item)
      // console.log("update :;:", updateConstructLabel);
      return {
        ...state,
        contextData: {
          ...state?.contextData,
          construct_label: updateConstructLabel
        }
      }

    }
    case 'UPDATE_BEHAVIOR_PERCENTAGE': {
      const behaviorData = state?.contextData?.behaviors;
      const sectionData = behaviorData[state.activeBehaviorsection];
      const updatedSection = updateBehaviors(sectionData, action.payload.label, action.payload.value);
      return {
        ...state,
        isUpdateBehaviors: true,
        contextData: {
          ...state?.contextData,
          behaviors: {
            [state.activeBehaviorsection]: updatedSection,
          }
        }
      }
    }
    case 'RESET_BEHAVIOR_PERCENTAGE': {
      const behaviorData = state?.contextData?.behaviors;
      const sectionData = behaviorData[state.activeBehaviorsection];
      const resetSection = resetBehaviors(sectionData);
      // let { prediction_value } = action.payload
      // let updateConstructLabel = state?.contextData?.construct_label.map(item => prediction_value[item?.behavior_graph_key] ? { ...item, percentage: +prediction_value[item?.behavior_graph_key] } : item)
      // console.log("Reste :;:", updateConstructLabel);

      return {
        ...state,
        isUpdateBehaviors: false,
        // contextData: action.payload?.data
        contextData: {
          ...state?.contextData,
          behaviors: {
            [state.activeBehaviorsection]: resetSection,
          }
        }
      }
    }
    case 'FETCH_GAME_TABS_STATUS_FOR_REPORTING_SUCCESS': {
      let tabs = updateActiveTabs(state?.tabs, action.payload?.data)
      let activeTab = tabs.find(tab =>  !tab?.disabled)

      return {
        ...state,
        tabs: tabs,
        activeTab: activeTab?.value
      }
    }
    default:
      return state;
  }

}

export default studentPerformanceConstructReducer;
